import { Box, Text } from "@chakra-ui/react";

type Iprops = {
  height?: string;
};

const Logo = ({}: Iprops) => {
  return (
    <Box mb={"1rem"} p={"1rem"}>
      {/* <Image
        onClick={() =>
          window.location.assign("https://bellu.ai/dashboard/learn")
        }
        cursor={"pointer"}
        h={height ?? "1.4rem"}
        src={assets.icons.logo}
        alt="bellu.ai logo"
      /> */}
      <Text
        onClick={() =>
          window.location.assign("https://bellu.ai/dashboard/learn")
        }
        fontSize={"4xl"}
        cursor={"pointer"}
        fontFamily={"serif"}
        fontWeight={"bold"}
      >
        Bellu.ai
      </Text>
    </Box>
  );
};

export default Logo;
